import { DEFAULT_QUANTIFY_SORT_BY } from '@modules/quantify/constants';
import {
  QuantifyReportDataPoint,
  QuantifyState,
} from '@modules/quantify/store/types';
import {
  getDefaultSortByForTopSelection,
  getQuantifyTableRowsVariants,
} from '@modules/quantify/utils';

interface getUpdatedSortyByIfRequiredParams {
  tableRows: QuantifyReportDataPoint[];
  sortBy: QuantifyState['metadata']['sortBy'];
  shouldShowAnomalies: boolean;
}

export function getUpdatedSortyByIfRequired({
  tableRows,
  sortBy,
  shouldShowAnomalies,
}: getUpdatedSortyByIfRequiredParams) {
  if (shouldShowAnomalies) {
    return getDefaultSortByForTopSelection({
      records: tableRows,
      shouldShowAnomalies,
    });
  }

  if (sortBy?.field === 'label' || sortBy?.field === 'value') {
    return sortBy;
  }

  const { variantLabels } = getQuantifyTableRowsVariants(tableRows);
  const isStaleSortBy = !variantLabels.includes(String(sortBy?.field));

  if (!isStaleSortBy && sortBy) {
    return sortBy;
  }

  return DEFAULT_QUANTIFY_SORT_BY;
}
